<script setup lang="ts">
  import { computed } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'

  import useI18n from '@/composables/useI18n'
  import useCourse from '@/composables/useCourse'

  import eventBus from '@/main'

  const { course } = useCourse()
  const { translateString } = useI18n()

  defineProps({
    nextActionDisabled: {
      type: Boolean,
      default: false,
    },
  })

  defineEmits(['show-details', 'next-action'])

  const nextActionText = computed(() => {
    if (course.value?.purchased) {
      return translateString('courses.continue')
    }

    return translateString('courses.keepTesting')
  })

  const showCourseDetails = () => {
    eventBus.$emit('show-modal', {
      modalContentComponent: 'CourseDetailsModal',
      cssClass: 'course-details-modal',
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
      },
    })
  }
</script>

<template lang="pug">
.course-details-action
  .cta
    KetchUpButton.tertiary(@click.native='showCourseDetails')
      h4 {{ $t('courses.courseDetails') }}
    KetchUpButton.secondary(@click.native='$emit("next-action")', :disabled='nextActionDisabled')
      h4 {{ nextActionText }}
</template>

<style lang="postcss" scoped>
  .course-details-action {
    @apply ketch-flex ketch-flex-col ketch-space-y-c30;

    .cta {
      @apply ketch-flex ketch-items-center ketch-space-x-c10;

      button {
        @apply ketch-flex-1 ketch-w-full;
      }
    }
  }
</style>
